"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  d: "M1 8a7 7 0 1114 0A7 7 0 011 8zm7-8a8 8 0 100 16A8 8 0 008 0zm-.55 4.52c-.4.18-.74.52-.9.9a.5.5 0 01-.92-.38 2.8 2.8 0 011.4-1.43c.61-.28 1.34-.36 2.01-.07 1.36.58 1.77 2.4.95 3.67-.2.32-.44.56-.66.77-.1.1-.2.18-.3.26L9 8.28l-.29.25c-.17.17-.28.32-.36.47a1 1 0 00-.08.56.5.5 0 11-.99.1 2 2 0 01.17-1.09c.15-.3.36-.55.57-.75l.32-.3.04-.03.27-.24c.2-.18.37-.37.5-.58.54-.84.2-1.92-.5-2.21-.36-.16-.8-.13-1.2.06zm1.28 7.5a.78.78 0 11-1.57 0 .78.78 0 011.57 0z"
}));

exports.default = _default;